import React from 'react';
import './App.css';

// Importowanie obrazów
import amicaLogo from './producers/amica.jpg';
import ardoLogo from './producers/ardo.jpg';
import aristonLogo from './producers/ariston.jpg';
import bekoLogo from './producers/beko.jpg';
import boschLogo from './producers/bosch.jpg';
import brandtLogo from './producers/brandt.jpg';
import electroluxLogo from './producers/electrolux.jpg';
import indesitLogo from './producers/indesit.jpg';
import mastercookLogo from './producers/mastercook.jpg';
import samsungLogo from './producers/samsung.jpg';
import siemensLogo from './producers/siemens.jpg';
import whirlpoolLogo from './producers/whirlpool.jpg';

const brands = [
  { name: 'Amica', logo: amicaLogo },
  { name: 'Ardo', logo: ardoLogo },
  { name: 'Ariston', logo: aristonLogo },
  { name: 'Beko', logo: bekoLogo },
  { name: 'Bosch', logo: boschLogo },
  { name: 'Brandt', logo: brandtLogo },
  { name: 'Electrolux', logo: electroluxLogo },
  { name: 'Indesit', logo: indesitLogo },
  { name: 'Mastercook', logo: mastercookLogo },
  { name: 'Samsung', logo: samsungLogo },
  { name: 'Siemens', logo: siemensLogo },
  { name: 'Whirlpool', logo: whirlpoolLogo }
];

const Brands = () => {
  return (
    <section className="Brands">
    
      <ul>
        {brands.map((brand, index) => (
          <li key={index}>
            <img src={brand.logo} alt={brand.name} />
      
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Brands;
